import { map, sortBy } from 'lodash';
import template from '../directive/serviceAppointments.html';

interface ServiceAppointmentsScope extends ng.IScope {
  activeAppointmentId: string;
  appointmentsToService: todo;
  viewServiceAppointment(appointment: todo): void;
}

const serviceAppointments: angular.IDirectiveFactory = (
  $routeParams: ng.route.IRouteParamsService,
  $resource: ng.resource.IResourceService,
  $rootScope: ng.IRootScopeService & {
    appointmentsToService: todo;
    viewDashAppointment(appointment: todo, options: { sids: string[] }): void;
  },
) => {
  const link = (scope: ServiceAppointmentsScope) => {
    scope.activeAppointmentId = $routeParams.appointmentId;
    $resource('/appointments/headers').query(
      { sids: $routeParams.sids },
      (details: todo[]) => {
        $rootScope.appointmentsToService = sortBy(details, 'order');
        scope.appointmentsToService = $rootScope.appointmentsToService;
      },
    );

    scope.viewServiceAppointment = appointment => {
      $rootScope.viewDashAppointment(appointment, {
        sids: map($rootScope.appointmentsToService, 'id'),
      });
    };
  };

  return {
    link,
    template,
  };
};

serviceAppointments.$inject = ['$routeParams', '$resource', '$rootScope'];

export default serviceAppointments;
